import React from "react";
import { MultiSelect } from "./multiSelect";
import { SingleSelect } from "./singleSelect";

const QuestionAnswer = ({
  questionValue,
  pIndex,
  value,
  index,
  gotoOption,
  getOptionValue,
  getGotoValue,
  deleteAnswerOption,
  productFamilyCode,
  productMaterialCode,
  addRuleData,
  productAttributeOrderChange,
}) => {
  const { type, addOption, optionType } = questionValue;
  const length = questionValue?.options?.length;
  if (type === "singleselect") {
    return (
      <SingleSelect
        name="option"
        index={index}
        count={length}
        value={value}
        pIndex={pIndex}
        getOptionValue={getOptionValue}
        getGotoValue={getGotoValue}
        gotoOption={gotoOption}
        addOption={addOption}
        deleteAnswerOption={deleteAnswerOption}
        optionType={optionType}
        getFamilyCode={(code, i, p, filter) => productFamilyCode(code, i, p, filter)}
        getMaterialCode={(code, i, p, filter) => productMaterialCode(code, i, p, filter)}
        addRuleData={() => addRuleData(value?.rule, pIndex, index)}
        productAttributeOrderChange={productAttributeOrderChange}
      />
    );
  }

  if (type === "multiselect") {
    return (
      <MultiSelect
        index={index}
        value={value}
        pIndex={pIndex}
        getOptionValue={getOptionValue}
        getGotoValue={getGotoValue}
        gotoOption={gotoOption}
        deleteAnswerOption={deleteAnswerOption}
      />
    );
  }

  return null;
};

export default QuestionAnswer;
